import fetchToken from './fetch-token';

export default async function retrieveOrFetchToken(
    locale: string
): Promise<string> {
    let token = localStorage.getItem('trueFitToken');
    if (!token) {
        token = await fetchToken(locale);
    }
    return token;
}
